import React, { useState } from 'react';
import { Fab, Tooltip, Zoom } from '@mui/material';
import { BugReport as BugReportIcon } from '@mui/icons-material';
import BugReportDialog from './BugReportDialog';

const FloatingBugReportButton = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="Report a Bug" placement="left" arrow>
        <Zoom in={true}>
          <Fab
            color="primary"
            aria-label="report bug"
            onClick={() => setOpen(true)}
            sx={{
              position: 'fixed',
              bottom: 24,
              right: 24,
              zIndex: 1000,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              '&:hover': {
                boxShadow: '0 6px 16px rgba(0,0,0,0.2)',
                transform: 'scale(1.05)',
              },
              transition: 'all 0.3s ease-in-out',
            }}
          >
            <BugReportIcon />
          </Fab>
        </Zoom>
      </Tooltip>
      <BugReportDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default FloatingBugReportButton;


